/*
 * @Author: Ashley.Liu
 * @Date: 2022-08-09 10:25:48
 * @LastEditTime: 2022-08-23 19:19:46
 * @Description: desc
 */
import request from './helpers'

export function getHelperLatestMarkdsByUri(helpModuleId) {
  return request({
    url: '/esms/1.0/helper?uri=' + helpModuleId,
    method: 'get'
  })
}

export function getHelperMarkdsByUriVersion(params) {
  return request({
    url: `/esms/1.0/helper/getHelperByVersion`,
    method: 'get',
    params
  })
}

export function getAllVersion(helpModuleId) {
  return request({
    url: '/esms/1.0/helper/allVersion?uri=' + helpModuleId,
    method: 'get'
  })
}

export function canEditHelp(helpModuleId, version) {
  return request({
    url: `/esms/1.0/helper/canEdit?uri=` + helpModuleId + '&version=' + version,
    method: 'get'
  })
}

export function saveHelp(data) {
  return request({
    url: `/esms/1.0/helper/save`,
    method: 'post',
    data
  })
}

export function deleteVersion(helpModuleId, version) {
  return request({
    url: `/esms/1.0/helper/delete?uri=` + helpModuleId + '&version=' + version,
    method: 'delete'
  })
}

export function releaseLock(helpModuleId) {
  return request({
    url: `/esms/1.0/helper/releaseLock?uri=` + helpModuleId,
    method: 'get'
  })
}
